import React from "react";
import Navigation from "../../Components/Nav/Navigation";
import Comingsoon from "../../Images/comingSoon.gif"
const Construction = () => {
  return (

    <>
    <Navigation />
    <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-3xl font-semibold text-center mb-4">Coming Soon</h1>

      
        <p className="text-gray-600 text-center">
          We are working hard to bring you something amazing. Stay tuned!
        </p>
{/* 
        <img
          src={Comingsoon}
          alt="Coming Soon GIF"
          className="mx-auto mb-4"
        /> */}
      </div>
    </div>
    </>
  );
};

export default Construction;
